import React from 'react'

import Base from '../_Base'

const GoogleLogo = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M22.56 12.25C22.56 11.47 22.49 10.72 22.36 10H12V14.26H17.92C17.66 15.63 16.88 16.79 15.71 17.57V20.34H19.28C21.36 18.42 22.56 15.6 22.56 12.25Z"
      fill="#4285F4"
    />
    <path
      d="M12 22.9996C14.97 22.9996 17.46 22.0196 19.28 20.3396L15.71 17.5696C14.73 18.2296 13.48 18.6296 12 18.6296C9.13999 18.6296 6.70999 16.6996 5.83999 14.0996H2.17999V16.9396C3.98999 20.5296 7.69999 22.9996 12 22.9996Z"
      fill="#34A853"
    />
    <path
      d="M5.84 14.0903C5.62 13.4303 5.49 12.7303 5.49 12.0003C5.49 11.2703 5.62 10.5703 5.84 9.91031V7.07031H2.18C1.43 8.55031 1 10.2203 1 12.0003C1 13.7803 1.43 15.4503 2.18 16.9303L5.03 14.7103L5.84 14.0903Z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.38C13.62 5.38 15.06 5.94 16.21 7.02L19.36 3.87C17.45 2.09 14.97 1 12 1C7.69999 1 3.98999 3.47 2.17999 7.07L5.83999 9.91C6.70999 7.31 9.13999 5.38 12 5.38Z"
      fill="#EA4335"
    />
  </Base>
)

export default GoogleLogo
